module.exports = "<div id=\"buttons-in-message\">\n  <div *ngFor=\"let button of buttons\" class=\"div-button\">\n      <!-- <div class=\"alt\">{{button.value}}</div> -->\n      <div *ngIf=\"button.type === 'text'\" class=\"button-in-msg {{button.class}}\" (click)=\"actionButton(button.value)\" title=\"{{button.value}}\">{{button.value}}</div> \n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/message-attachment/message-attachment.component.html
// module id = ./src/app/components/message-attachment/message-attachment.component.html
// module chunks = main